<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.subject schedule") }}</h2>
    </div>
    <div class="col-lg-2">
      <span class="tooltip-wrapper pointer" style="float:right">
        <i class="fa fa-times close cursor-pointer" @click="$router.go(-1)"></i>
        <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row"></div>
    <div class="row">


      <div class="col-lg-6 mb-1">
        <div class="ibox-body">
          <div class="ibox-content horizondalscroll minheight">
            <ul class="tree pl-1">
              <li>
                <input type="checkbox" :id="subjectId" :ref="subjectId" @change="getVisits(subjectId, 0)" />
                <label :for="subjectId" class="tree_label">{{
                  subjectname
                }}</label>
                <ul v-if="hasadditionalforms[subjectId]">
                  <li>
                    <input type="checkbox" :id="subjectId + 'additionalforms'"
                      @change="getAdditionalForms(subjectId)" />
                    <label :for="subjectId + 'additionalforms'" class="tree_label">
                      Additional forms
                    </label>
                  </li>

                  <!-- Grouped Forms with Collapsible Folders -->
                  <ul v-if="groupedAdditionalForms[subjectId] && additionalformchecked[subjectId]">
                    <li v-for="(group, templateId) in groupedAdditionalForms[subjectId]" :key="templateId"
                      class="group-folder-item">
                      <!-- Collapsible Group Folder with Checkbox -->
                      <input type="checkbox" :id="subjectId + templateId + 'group'"
                        :checked="expandedAdditionalGroups[subjectId] && expandedAdditionalGroups[subjectId][templateId]"
                        @change="toggleAdditionalGroup(subjectId, templateId)" />
                      <label :for="subjectId + templateId + 'group'" class="tree_label tree_folder_label">
                        {{ group.templateName }} ({{ group.forms.length }})
                      </label>

                      <!-- Individual Forms - Shown only when group is expanded -->
                      <ul v-if="expandedAdditionalGroups[subjectId] && expandedAdditionalGroups[subjectId][templateId]"
                        class="group-forms-list">
                        <li v-for="form in group.forms" :key="form.formId">
                          <input type="checkbox" :id="form.formId + subjectId"
                            @click.prevent="gotoform(form, subjectId)" />
                          <label class="tree_label" :for="form.formId + subjectId" @click.stop>
                            <!-- {{
                              form.formStatus === "Completed"
                                ? form.templateName +
                                " - " +
                                (form.visitCompletedDate
                                  ? filter(form.visitCompletedDate) + "-"
                                  : "")
                                : form.templateName
                            }} -->
                            {{ form.templateName }}


                            <span class="badge custom-form-tooltip-wrapper ml-2"
                              :style="`background-color: ${form.formStatusHex}; color: black;`">
                              {{ form.formStatus }}</span>

                          </label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </ul>
                <ul v-if="visitobj?.[subjectId]?.[0]?.length">
                  <li v-for="(visit, vIndex) in visitobj[subjectId][0]" :key="visit.sheduleId">
                    <input v-if="visit.visitNo != '' && visit.visitNo != null" type="checkbox"
                      :id="visit.sheduleId + subjectId" @change="
                        getactivities(
                          subjectId,
                          visit.visitNo,
                          visit.visitName,
                          vIndex,
                          visit.sheduleId,
                          visit.patientNo
                        )
                        " />
                    <label v-if="visit.visitNo != '' && visit.visitNo != null" :for="visit.sheduleId + subjectId"
                      class="tree_label">
                      <b>{{ visit.visitNo }} - {{ visit.visitName }}</b> - ( {{ setdate(visit) }} )
                      <span class="badge custom-tooltip-wrapper"
                        @mouseenter="showPopover(`visitStatus-${sIndex}-${0}-${vIndex}`)"
                        @mouseleave="hidePopover(`visitStatus-${sIndex}-${0}-${vIndex}`)"
                        :popovertarget="`visitStatus-${sIndex}-${0}-${vIndex}`"
                        :style="`background-color: ${visit.visitStatusHex}; color: black; anchor-name:--visitStatus-${sIndex}-${0}-${vIndex};`">
                        {{ visit.visitStatus }}</span><span class="custom-tooltip-text"
                        v-if="visit.visitStatusDescription" popover :id="`visitStatus-${sIndex}-${0}-${vIndex}`"
                        :style="`position-anchor:--visitStatus-${sIndex}-${0}-${vIndex};`">{{
                          visit.visitStatusDescription }}</span>
                    </label>
                    <span class="position-relative cursor-pointer float-right px-2"
                      @click.prevent="toggleSidePopup(sIndex, 0, vIndex)"
                      v-on:clickout="closeSidePopup(sIndex, 0, vIndex)">
                      <i class="fa fa-ellipsis-v"></i>
                    </span>
                    <div class="plan-side-popup" v-if="
                      showSidePopup[sIndex] &&
                      showSidePopup[sIndex][0] &&
                      showSidePopup[sIndex][0][vIndex]
                    ">
                      <!-- Plan Last Next Visit Will be empty-->
                      <div v-if="vIndex < visitobj[subjectId][0].length - 1"
                        @click.prevent="openPlanNextVisitModal(visitobj[subjectId][0][vIndex + 1])">
                        Plan Next Visit
                      </div>
                      <div @click.prevent="openManageVisitPopup(visit)">
                        Manage Visit
                      </div>
                      <div v-if="visit.visitStatus != 'Completed'" @click.prevent="
                        openChangeStatusmodal(
                          visit.studyId,
                          visit.visitNo,
                          subjectId,
                          visit.visitStatus,
                          0,
                          'Visit'
                        )
                        ">
                        {{ $t("navigations.change status") }}
                      </div>
                    </div>
                    <ul>
                      <li v-if="observationValue[visit.visitNo + subjectId] == true">
                        <input type="checkbox">
                        <label
                          @click.prevent="toggleObservationFolder(visit.siteCode, visit.patientNo, visit.visitName, visit.visitNo, subjectId)"
                          class="tree_label">{{ $t("navigations.observations") }}</label>

                        <template v-if="categoryFlags[visit.visitNo + subjectId]">
                          <div v-for="docType in categoryFlags[visit.visitNo + subjectId]" :key="docType.id"
                            class="tree-node mb-2">
                            <div @click.prevent="docType.flag = !docType.flag">
                              <span class="cursor-pointer">
                                <i class="fa fa-file-code-o text-primary me-2"></i>
                                {{ docType.category }}
                              </span>
                            </div>
                            <div class="row" v-if="docType.flag == true">
                              <div class="d-flex pt-2 pl-4 cursor-pointer" v-for="(value, index) in docType.code"
                                :key="index"
                                @click.prevent="selectDocument(site.siteCode, patient.subjectId, docType.document[index], visit.visitName, subjectId, patient.siteId)">
                                <span class="mr-1">{{ value }}</span>
                                <span v-if="docType.effectiveDateTime[index]">
                                  ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                </span>
                              </div>
                            </div>


                          </div>
                        </template>


                      </li>
                    </ul>
                    <template v-if="(activityobject?.[`${visit.visitNo}_${subjectId}`]?.[vIndex] || []).length">
                      <ul
                        v-for="(singleactivity, activityindex) in (activityobject?.[`${visit.visitNo}_${subjectId}`]?.[vIndex] || [])"
                        :key="singleactivity.activityId">
                        <li>
                          <input v-if="singleactivity.activityId"
                            :id="activityInputId(singleactivity, subjectId, visit)" type="checkbox" @change="
                              getFormsByVisit(subjectId,
                                visit.visitNo,
                                visit.visitName,
                                vIndex,
                                visit.sheduleId,
                                activityindex,
                                singleactivity.activityId,
                                singleactivity.activityOrder
                              )
                              " />
                          <label class="tree_label" :for="activityInputId(singleactivity, subjectId, visit)"
                            @click.stop>

                            <div>

                              <span>

                                {{ singleactivity.activityName }}
                                <span class="badge custom-form-tooltip-wrapper"
                                  :style="`background-color: ${singleactivity.statusHex}; color: black;`">
                                  {{ singleactivity.status }}</span>
                              </span>
                              <button v-if="singleactivity.formStatus !== 'Completed'"
                                :popovertarget="popoverId(singleactivity.activityId, sIndex, 0, vIndex)"
                                :anchor="popoverId('visitForms', sIndex, 0, vIndex)"
                                class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                <i class="fa fa-ellipsis-v"></i>
                              </button>
                              <div :id="popoverId(singleactivity.activityId, sIndex, 0, vIndex)" popover
                                class="visit-popup-menu">
                                <button @click.prevent.stop="
                                  openChangeStatusmodalforactivity(
                                    singleactivity.actScheduleId,
                                    singleactivity.status,
                                    subjectId,
                                    visit.visitNo,
                                    visit.visitName,
                                    vIndex,
                                    visit.sheduleId,
                                    popoverId(singleactivity.activityId, sIndex, 0, vIndex),
                                  )
                                  " class="popup-menu-block text-left w-100">
                                  {{ $t("navigations.change status") }}
                                </button>
                                <button @click.prevent="
                                  openModal(
                                    {
                                      visitNo: visit.visitNo,
                                      visitName: visit.visitName,
                                      sheduleId: visit.sheduleId,
                                      studyId: visit.studyId,
                                      visitId: singleactivity.visitId,
                                      actScheduleId: singleactivity.actScheduleId,
                                      subjectId: singleactivity.subjectId,
                                      activityId: singleactivity.activityId,
                                      activityName: singleactivity.activityName
                                    },
                                    patient.subjectId,
                                    site.siteCode,
                                    singleactivity.status,
                                    popoverId(singleactivity.activityId, sIndex, 0, vIndex)
                                  )
                                  " class="popup-menu-block text-left w-100">
                                  {{ $t('navigations.new form') }}
                                </button>


                              </div>

                            </div>
                          </label>
                          <template v-if="visitFormObj[visit.visitNo + subjectId]">
                            <ul>
                              <li v-for="singlevisit in visitFormObj[
                                visit.visitNo + subjectId
                              ][activityindex]" :key="singlevisit.sheduleId">

                                <input v-if="singlevisit.templateName" type="checkbox"
                                  :id="formInputId(singlevisit, 0, vIndex, activityindex)" @click.prevent="
                                    gotoform(singlevisit, subjectId)
                                    " />
                                <label class="tree_label" :for="formInputId(singlevisit, 0, vIndex, activityindex)"
                                  @click.stop>

                                  <div class="d-flex">

                                    <div class="d-flex align-items-center">
                                      <p class="mb-0" style="max-width: 28ch;">
                                        <!-- {{
                                          singlevisit.formStatus === "Completed"
                                            ? singlevisit.templateName +
                                            " - " +
                                            (singlevisit.visitCompletedDate
                                              ? filter(singlevisit.visitCompletedDate) + "-"
                                              : "")
                                            : singlevisit.templateName
                                        }} -->
                                        {{ singlevisit.templateName }}
                                      </p>
                                      <span class="badge custom-form-tooltip-wrapper ml-2"
                                        @mouseenter="showPopover(`formStatus-${singlevisit.sheduleId}-${0}-${vIndex}`)"
                                        @mouseleave="hidePopover(`formStatus-${singlevisit.sheduleId}-${0}-${vIndex}`)"
                                        :popovertarget="`formStatus-${singlevisit.sheduleId}-${0}-${vIndex}`"
                                        :style="`background-color: ${singlevisit.formStatusHex}; color: black; anchor-name:--formStatus-${singlevisit.sheduleId}-${0}-${vIndex};`">
                                        {{ singlevisit.formStatus }}</span>
                                      <span v-if="singlevisit.formStatusDescription" popover
                                        class="custom-form-tooltip-text"
                                        :id="`formStatus-${singlevisit.sheduleId}-${0}-${vIndex}`"
                                        :style="`position-anchor:--formStatus-${singlevisit.sheduleId}-${0}-${vIndex};`">
                                        {{ singlevisit.formStatusDescription }}</span>
                                    </div>


                                    <button :popovertarget="popoverId(singlevisit.sheduleId, sIndex, 0, vIndex)"
                                      :anchor="popoverId('visitForms', sIndex, 0, vIndex)"
                                      class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                      <i class="fa fa-ellipsis-v"></i>
                                    </button>
                                    <div :id="popoverId(singlevisit.sheduleId, sIndex, 0, vIndex)" popover
                                      class="visit-popup-menu">
                                      <button v-if="singlevisit.formStatus !== 'Completed'" @click.prevent.stop="
                                        openChangeStatusmodal(
                                          visit.studyId,
                                          visit.visitNo,
                                          subjectId,
                                          visit.visitStatus,
                                          vIndex,
                                          'Form',
                                          popoverId(singlevisit.sheduleId, sIndex, 0, vIndex),
                                          visit.visitName,
                                          singlevisit.formStatus,
                                          singlevisit.formId,
                                          singlevisit.sheduleId
                                        )
                                        " class="popup-menu-block text-left w-100">
                                        {{ $t("navigations.change status") }}
                                      </button>
                                      <button
                                        v-if="roleprivileges.includes('Subject Schedule Change eCRF') && singlevisit.formStatus !== 'Completed'"
                                        @click.prevent="
                                          ChangeTemplatePopup(
                                            visit.studyId,
                                            visit.visitNo,
                                            subjectId,
                                            visit.visitStatus,
                                            vIndex,
                                            'Form',
                                            popoverId(singlevisit.sheduleId, sIndex, 0, vIndex),
                                            visit.visitName,
                                            singlevisit.formStatus,
                                            singlevisit.sheduleId,
                                            singlevisit.templateId
                                          )
                                          " class="popup-menu-block text-left w-100">
                                        {{ $t("navigations.change ecrf") }}
                                      </button>
                                      <button
                                        v-if="singlevisit.formStatus == 'Completed' && singlevisit.sdvAssigned == false && singlevisit.isSdv == true"
                                        @click.prevent.stop="
                                          assignSdv(
                                            singlevisit.formId,
                                            singlevisit.templateId,
                                            popoverId(singlevisit.sheduleId, sIndex, 0, vIndex),
                                          )
                                          " class="popup-menu-block text-left w-100">
                                        {{ $t("navigations.assign sdv") }}
                                      </button>
                                    </div>
                                  </div>
                                </label>
                              </li>
                            </ul>
                          </template>
                        </li>
                      </ul>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mb-1">
        <div class="ibox-body minheight">
          <div class="ibox-title style_2">
            <h5 class="float-left">Subject-level/Event-based Forms</h5>
          </div>
          <div class="ibox-content border-bottom-0">
            <!-- Search and Filter Section -->
            <div class="row mb-3">
              <div class="col-lg-9">
                <div class="form-group mb-0">
                  <label class="mb-2">{{ $t("navigations.ecrf") }}</label>
                  <select class="form-select" v-model="selectedFormScope" name="formScope">
                    <option value="">{{ $t("navigations.all") }}</option>
                    <option v-for="template in subjectTemplates" :key="template.templateName"
                      :value="template.templateName">
                      {{ template.templateName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 d-flex align-items-end">
                <button type="button" class="w-100 save_btn mx-lg-1 align-self-end" @click="listEcrfForms()()">
                  {{ $t("navigations.search") }}
                </button>
              </div>
            </div>
            <div class="text-center" v-if="formsLoader === true">
              <img src="../../assets/img/loading.gif" width="15" class="" alt="Waiting for login" />
              <div>
                {{ $t("navigations.please wait while the list is being loaded") }}
              </div>
            </div>
            <!-- Table Section -->
            <div v-else class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Index </th>
                    <!-- <th> {{ $t("navigations.index") }} </th> -->
                    <th class="sort_block" @click="SortSelectforms('formName', 0)" id="0">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.form name") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelectforms('createdAt', 1)" id="1">
                      <div class="d-flex flex-row justify-content-between">
                        Date fetched
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelectforms('FhirCreatedAt', 2)" id="2">
                      <div class="d-flex flex-row justify-content-between">
                        Visit Date
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="text-center">View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in recentecrfList" :key="item.formId">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.formName }}</td>
                    <td>{{ filter(item.createdAt) }}</td>
                    <td>{{ filter(item.fhirCreatedAt) }}</td>
                    <td class="text-center">
                      <i class="fa fa-eye editicon" aria-hidden="true" @click.prevent="
                        viewform(item.formId, item.siteId, item.patientId, item.sheduleId)">
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Pagination Section -->
            <div class="row mt-3 mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination v-model="currentRecentformPage" :pages="totalformsPages" :range-size="1"
                      active-color="#618bd7" @update:modelValue="listEcrfForms" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-6 mb-1">
        <div class="ibox-body minheight">
          <div class="ibox-title style_2">
            <h5 class="float-left">Forms for Review </h5>
          </div>
          <div class="ibox-content border-bottom-0">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
             
                    <th class="sort_block" @click="SortSelectforms('formName', 0)" id="0">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.form name") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelectforms('createdAt', 0)" id="0">
                      <div class="d-flex flex-row justify-content-between">
                        Date fetched
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelectforms('fhirCreatedAt', 0)" id="0">
                      <div class="d-flex flex-row justify-content-between">
                          FHIR Created date
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
     
                    <th class="text-center">View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in recentformList" :key="item.formId">
                    <td>{{ item.formNameDisplay }}</td>
                    <td>{{ filter(item.createdAt) }}</td>
                    <td>{{ filter(item.fhirCreatedAt) }}</td>
                    <td class="text-center">
                      <i class="fa fa-eye editicon" aria-hidden="true" @click.prevent="
                        viewform(item.formId, item.siteId, item.patientId, item.sheduleId)
                        "></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-3 mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                      <v-pagination
                        v-model="currentRecentformPage"
                        :pages="totalformsPages"
                        :range-size="1"
                        active-color="#618bd7"
                        @update:modelValue="listrecentvisitForms"
                      />
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <!-- activate next visit -->
  <customModal v-if="plannextvisitPopup == true" :containersm="true" @closeModal="closeplannextvisitModal()">
    <template #title>
      Plan Next Visit
    </template>
    <template #body>
      <div class="container mt-3">
        <div class="row justify-content-center">
          <div class="p-2">
            <div class="col-md-12 d-flex mt-2">
              <label class="form-label col-md-6"> Visit Name</label>
              <select class="form-select no-arrow" v-model="createvisitobj.visitName" disabled
                @change="changeVisitDate">
                <option selected value="">All</option>
                <option v-for="schedule in visitobj[createvisitobj.patientId][0]" :key="schedule.sheduleId"
                  :value="schedule.visitName">
                  {{ schedule.visitName }}
                </option>
              </select>
            </div>
            <!-- Visit Start Date -->
            <div class="col-md-12 d-flex mt-2">
              <label class="form-label col-md-6">Planned Visit Date</label>
              <input type="datetime-local" disabled v-model="oldvisitdatetDate" class="form-control col-md-6" />
            </div>

            <!-- Visit End Date -->
            <div class="col-md-12 d-flex mt-2">
              <label class="form-label col-md-6">New Visit Date
                <sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <input type="datetime-local" v-model="newvisitDate" class="form-control col-md-6" />
            </div>

            <div class="row">
              <div class="col text-end mt-2">
                <button type="button" @click.prevent="Createnewvisitfun(createvisitobj)"
                  class="btn btn-primary btn-sm px-4" :disabled="showLoader">
                  <span v-if="showLoader == false">Save</span>
                  <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>



    </template>
  </customModal>
  <!-- manage visit popup -->
  <customModal v-if="ManageVisitPopup == true" :containersm="true" @closeModal="closeManageVisitModal()">
    <template #title>
      Manage Visit
    </template>
    <template #body>
      <div class="container mt-3">
        <div class="row justify-content-center">
          <div class="p-2">

            <!-- Visit Start Date -->
            <div class="col-md-12 d-flex">
              <label class="form-label col-md-6">Visit Start Date<sup><i
                    class="fa fa-asterisk required"></i></sup></label>
              <input type="datetime-local" v-model="actualVisitStartDate" class="form-control col-md-6" />
            </div>

            <!-- Visit End Date -->
            <div class="col-md-12 d-flex mt-2">
              <label class="form-label col-md-6">Visit End Date</label>
              <input type="datetime-local" v-model="actualVisitEndDate" class="form-control col-md-6" />
            </div>

            <!-- Completed Checkbox -->
            <div class="col-md-12 text-start">
              <div class="form-check mt-4">
                <input class="form-check-input" type="checkbox" id="completedCheck" v-model="isCompleted" />
                <label class="form-check-label" for="completedCheck">
                  Mark this visit as completed
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col text-end">
                <button type="button" @click.prevent="updateactualvisitdates(managevisitobj)"
                  class="btn btn-primary btn-sm px-4" :disabled="showCreateLoader">
                  <span v-if="showCreateLoader == false">Save</span>
                  <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>



    </template>
  </customModal>
  <!-- Change schedule status  -->
  <ChangeSchedulestatus v-if="showChangeSchedule" :statusType="statusType" :changeStatus="changeStatus"
    :selectedScheduleId="scheduleId" :selectedFormId="selectedForm" @changeStatus="changedStatus()"
    @closeModal="closeChangeScheduleModal()" />
  <!-- Change activity status  -->
  <ChangeactivityStatusPopup v-if="showChangeActivity" :activitystatusreload="activitystatusreload"
    :currentstatus="currentactivitystatus" :activityid="selectedActivityid" @changeStatus="changedactivityStatus"
    @closeModal="closeChangeactivityModal()" />
  <mapformmodel v-if="showformmodelpopup" :formid=currentformid :scheduleId="selectedScheduleId"
    :subjectidpassed="this.subjectId" @closeformModal="showformmodelpopup = false" @formMapped="onFormMapped" />
</template>
<script src="./subject_tree.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "./tree.css";

/* Tooltip box */
.custom-tooltip-text,
.custom-form-tooltip-text {
  position: absolute;
  inset: auto;
  margin: 0;
  bottom: anchor(top);
  right: anchor(right);
  background-color: #616161;
  color: white;
  padding: 6px 10px;
  font-size: 0.75rem;
  border-radius: 4px;
  border: none;
  max-width: 180px;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-block-end: 4px;

}

.custom-tooltip-text:popover-open {
  display: grid;
}

.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.visit-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.visit-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.visit-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.visit-popup-menu>button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.visit-popup-menu>.popup-menu-block:hover,
.popup-submenu>div:hover {
  background-color: #e4eaf9;
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left);
}

/* CSS Popover Styles */
.linkstyle {
  cursor: pointer;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 18px;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}

.modal-wrapper-changetemplate {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  pointer-events: auto;
  overflow: hidden;
  z-index: 9999;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  /* background-color: aquamarine;  */
  margin: 0;
  padding: 5%;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(30%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.badge-genre {
  background-color: #b6bdbf;
  color: #ffffff;
}

.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.minheight {
  min-height: 460px;
}

.no-arrow.form-select {
  background-image: none !important;
  padding-right: 0.75rem;
}
</style>
